const localizers = {
  'Alerts.noAlerts.txt': () => `Для этого отчета не задано оповещений.`,
  'BirdImage.image.txt': () => `Изображение`,
  'ComboBox.clearFilter.txt': () => `Сбросить фильтр`,
  'ComboBox.defautValueNoData.fmt': ({categoryValue}) => `${categoryValue} (Нет данных)`,
  'ContextMenu.selectAll.txt': () => `Выбрать все`,
  'ContextMenu.clearSelection.txt': () => `Очистить выделение`,
  'ContextMenu.exportImage.txt': () => `Экспорт как изображение`,
  'ContextMenu.sortAscending.fmt': ({role}) => `${role}: по возрастанию`,
  'ContextMenu.sortDescending.fmt': ({role}) => `${role}: по убыванию`,
  'ContextMenu.sortAddAscending.fmt': ({role}) => `${role}: добавить по возрастанию`,
  'ContextMenu.sortAddDescending.fmt': ({role}) => `${role}: добавить по убыванию`,
  'ContextMenu.removeSortItem.fmt': ({role}) => `Удалить ${role} из сортировки`,
  'ContextMenu.removeSortLevel.txt': () => `Удалить уровень сортировки`,
  'ContextMenu.sort.txt': () => `Сортировка`,
  'ContextMenu.selectShortestPath.txt': () => `Выбрать кратчайший путь`,
  'ContextMenu.explain.txt': () => `Объяснить данные`,
  'ContextMenu.explainRole.txt': ({role}) => `Объяснить ${role}...`,
  'ContextMenu.manageColumns.txt': () => `Управление столбцами`,
  'DrillableTooltip.drill.txt': () => `ДЕТАЛИЗАЦИЯ`,
  'DrillableTooltip.tooltip.txt': () => `ПОДСКАЗКА`,
  'DrillableTooltip.links.txt': () => `ССЫЛКИ`,
  'DrillableTooltip.section.link.fmt': ({page}) => `Ссылка на страницу ${page}`,
  'DrillableTooltip.report.link.fmt': ({report}) => `Ссылка на отчет ${report}`,
  'DrillableTooltip.external.link.fmt': ({url}) => `Внешняя ссылка на ${url}`,
  'DrillableTooltip.notAvailable.txt': () => `Не доступно`,
  'Breadcrumb.all.fmt': ({label}) => `Все ${label}`,
  'BrowserCheck.title.txt': () => `Проверка WebGL`,
  'BrowserCheck.msg.txt': () => `WebGL отключен или не поддерживается вашим браузером.   \nЧтобы просмотреть отчет в стандартном средстве просмотра, щелкните OK.`,
  'EmailUtil.subject.multiple.txt': () => `Отчеты для просмотра`,
  'EmailUtil.tooLongEmail.txt': () => `Превышена предельная длина электронной почты. Выберите меньшее число отчетов для отправки по электронной почте.`,
  'HiddenSectionDialog.close.txt': () => `Закрыть`,
  'InfoPanel.information.txt': () => `Информация`,
  'InfoPanel.comments.txt': () => `Комментарии`,
  'InfoPanel.alerts.txt': () => `Оповещения`,
  'IncomingFilters.promptbars.txt': () => `Панели с параметрами`,
  'Information.title.txt': () => `Заголовок`,
  'Information.name.txt': () => `Имя:`,
  'Information.description.txt': () => `Описание:`,
  'Information.displayRules.txt': () => `Правила отображения:`,
  'Information.graphLevel.txt': () => `Уровень диаграммы`,
  'Information.reportLevel.txt': () => `Уровень отчета`,
  'Information.legend.txt': () => `Легенда`,
  'Information.incomingFilters.txt': () => `Входящие фильтры:`,
  'Information.noIncomingFilters.txt': () => `Входящие фильтры отсутствуют`,
  'Information.dataSourceFilters.txt': () => `Фильтры источников данных:`,
  'Information.interactiveFilters.txt': () => `Интерактивные фильтры:`,
  'MobileContainer.mobileBIMessage.txt': () => `Доступ к отчетам SAS на мобильном устройстве.`,
  'ObjectTypes.report.txt': () => `Отчет`,
  'ObjectTypes.Report.BI.txt': () => `Отчет SAS (2G)`,
  'ObjectTypes.Report.StoredProcess.txt': () => `Stored process report`,
  'ObjectTypes.StoredProcess.txt': () => `Хранимый процесс`,
  'MissingValues.label.txt': () => `(отсутствующие значения)`,
  'PromptContainer.apply.txt': () => `Применить`,
  'PromptContainer.cancel.txt': () => `Отмена`,
  'TextFieldTypeAhead.validation.range.fmt': ({min, max}) => `Значение должно быть числом от ${min} до ${max} включительно.`,
  'TextFieldTypeAhead.validation.numeric.txt': () => `Укажите допустимое числовое значение.`,
  'TextFieldTypeAhead.validation.string.txt': () => `Значение недопустимо для назначенных данных.`,
  'TextFieldTypeAhead.categoryAndMeasureTooltip.fmt': ({categoryLabel, measureLabel}) => `Введите: ${categoryLabel}, ${measureLabel}`,
  'TextFieldTypeAhead.categoryTooltip.fmt': ({categoryLabel}) => `Укажите: ${categoryLabel}`,
  'TextFieldTypeAhead.placeholder.fmt': ({placeholderLabel}) => `Ввести ${placeholderLabel}...`,
  'RangeSlider.tooltip.fmt': ({label, min, max}) => `${label}: ${min} - ${max}`,
  'PromptElement.categoryLabelValueAndMeasureLabelValueTooltip.fmt': ({categoryLabel, categoryValue, measureLabel, measureValue}) => `${categoryLabel}: ${categoryValue}, ${measureLabel}: ${measureValue}`,
  'PromptElement.categoryLabelValueTooltip.fmt': ({categoryLabel, categoryValue}) => `${categoryLabel}: ${categoryValue}`,
  'ReportContainer.back.txt': () => `Назад`,
  'ReportContainer.reportCorrupted.txt': () => `ОТЧЕТ ПОВРЕЖДЕН`,
  'ReportContainer.themeLoadFailed.txt': () => `Не удалось загрузить тему отчета.`,
  'ReportContainer.restoreButton.tip.txt': () => `Восстановить отчет`,
  'ReportContainer.restoreButtonAriaAnnounce.txt': () => `Отчет восстановлен`,
  'ReportContainer.renderError.txt': () => `Произошла ошибка. Отчет не может быть отображен.`,
  'ReportContainer.component.renderError.txt': () => `Произошла ошибка. Компонент не может быть отрисован.`,
  'ReportContentPage.open.txt': () => `Открыть...`,
  'ReportContentPage.refreshReport.txt': () => `Обновить отчет`,
  'ReportContentPage.editReport.txt': () => `Редактировать отчет`,
  'ReportContentPage.print.txt': () => `Печать...`,
  'ReportContentPage.email.txt': () => `Эл. почта...`,
  'ReportContentPage.export.txt': () => `Экспорт в Excel...`,
  'ReportContentPage.reportProperties.txt': () => `Свойства отчета`,
  'ReportContentPage.shareReport.txt': () => `Общий доступ к отчету`,
  'ReportContentPage.enableOverlays.txt': () => `Включить наложения объектов`,
  'ReportContentPage.disableOverlays.txt': () => `Отключить наложения объектов`,
  'ReportContentPage.link.txt': () => `Ссылка...`,
  'ReportContentPage.settings.txt': () => `Настройки...`,
  'ReportContentPage.editPlayback.txt': () => `Редактировать воспроизведение`,
  'ReportContentPage.playReport.txt': () => `Воспроизвести отчет`,
  'ReportContentPage.showFiltersButton.tip.txt': () => `Отобразить запрошенные фильтры`,
  'ReportContentPage.hideFiltersButton.tip.txt': () => `Скрыть запрошенные фильтры`,
  'ReportContentPage.reportFilters.txt': () => `Уровень отчета`,
  'ReportContentPage.pageFilters.txt': () => `Уровень страницы`,
  'ReportContentPage.refreshRequired.txt': () => `Необходимо обновить отчет`,
  'ReportContentPage.infoButton.tip.txt': () => `Панель информации`,
  'ReportContentPage.backButton.tip.txt': () => `Просмотреть все отчеты`,
  'ReportContentPage.overflowMenuButton.tip.txt': () => `Дополнительные параметры`,
  'ReportContentPage.itemGroupName.txt': () => `Отчеты`,
  'ReportContentPage.maximizeButton.tip.txt': () => `Развернуть отчет`,
  'ReportContentPage.closeButton.txt': () => `Закрыть отчет`,
  'ReportContentPage.maximizeButtonAriaAnnounce.txt': () => `Отчет максимизирован`,
  'ReportContentPage.resetReportState.txt': () => `Восстановить состояние отчета по умолчанию`,
  'ReportContentPage.summary.txt': () => `Показать сводку`,
  'ReportManagerPage.objectMenu.open.txt': () => `Открыть`,
  'ReportManagerPage.objectMenu.edit.txt': () => `Редактировать`,
  'ReportManagerPage.objectMenu.summary.txt': () => `Сводка`,
  'ReportManagerPage.objectMenu.properties.txt': () => `Свойства`,
  'ReportManagerPage.objectMenu.email.txt': () => `Эл. почта...`,
  'ReportManagerPage.objectMenu.print.txt': () => `Печать`,
  'ReportManagerPage.browseReportsButton.txt': () => `Обзор отчетов`,
  'ReportManagerPage.newReportButton.txt': () => `Новый отчет`,
  'ReportManagerPage.emptyView.message.txt': () => `Не найдено ни одного отчета.`,
  'ReportManagerPage.emptyView.browseReportsButton.txt': () => `Обзор отчетов`,
  'ReportManagerPage.tableView.name.txt': () => `Имя`,
  'ReportManagerPage.tableView.author.txt': () => `Автор`,
  'ReportManagerPage.tableView.lastModified.txt': () => `Последнее изменение`,
  'ReportManagerPage.openButton.tip.txt': () => `Открытие отчета`,
  'ReportManagerPage.emailButton.tip.txt': () => `Отправить отчет по электронной почте`,
  'ReportManagerPage.printButton.tip.txt': () => `Печать отчета как PDF`,
  'ReportManagerPage.propertiesButton.tip.txt': () => `Свойства отчета`,
  'ReportObject.multipleReferences.error.txt': () => `Использовать объекты отчета в нескольких контекстах невозможно.`,
  'ReportObject.notFound.error.txt': () => `Имя объекта невозможно найти в указанном отчете.`,
  'ReportObject.invalidPage.error.txt': () => `Указанная страница недействительна.`,
  'ReportPropertiesDialog.open.txt': () => `Открыть`,
  'ReportPropertiesDialog.close.txt': () => `Закрыть`,
  'ReportPropertiesDialog.name.txt': () => `Имя:`,
  'ReportPropertiesDialog.description.txt': () => `Описание:`,
  'ReportPropertiesDialog.keywords.txt': () => `Ключевые слова:`,
  'ReportPropertiesDialog.type.txt': () => `Тип:`,
  'ReportPropertiesDialog.location.txt': () => `Местоположение:`,
  'ReportPropertiesDialog.createdBy.txt': () => `Кем создано:`,
  'ReportPropertiesDialog.dateCreated.txt': () => `Дата создания:`,
  'ReportPropertiesDialog.modifiedBy.txt': () => `Кем изменено:`,
  'ReportPropertiesDialog.dateModified.txt': () => `Дата изменения:`,
  'ReportSections.newPageButton.txt': () => `Создать страницу`,
  'ReportSummaryDialog.title.txt': () => `Сводка`,
  'ReportSummaryDialog.open.txt': () => `Открыть`,
  'ReportSummaryDialog.cancel.txt': () => `Отмена`,
  'ReportSummaryDialog.close.txt': () => `Закрыть`,
  'ReportSummaryDialog.noSummary.txt': () => `Сводки недоступны.`,
  'ReportTileBody.modifiedBy.txt': () => `Кем изменено:`,
  'ReportTileBody.lastModified.txt': () => `Последнее изменение:`,
  'VAViewerSettingsProvider.reportViewer.txt': () => `Средство для просмотра отчетов SAS`,
  'VAViewerSettingsProvider.reportRefreshSettings.txt': () => `Обновить отчет`,
  'VAViewerSettingsProvider.reportAutoRefresh.txt': () => `Автоматическое обновление отчета`,
  'VAViewerSettingsProvider.reportRefreshFrequency.txt': () => `Ожидание в минутах до проверки обновлений:`,
  'VAViewerSettingsProvider.alert.group.label.txt': () => `Оповещения`,
  'VAViewerSettingsProvider.alert.field.label.txt': () => `Выберите оповещения по умолчанию:`,
  'VAViewerSettingsProvider.alert.email.txt': () => `Оповещения по электронной почте`,
  'VAViewerSettingsProvider.alert.sms.txt': () => `Оповещения по SMS`,
  'VAViewerSettingsProvider.alert.system.txt': () => `По умолчанию (настраивается администратором)`,
  'VAViewerSettingsProvider.generalSettings.txt': () => `Темы`,
  'VAViewerSettingsProvider.enableHighContrast.txt': () => `Переопределить тему отчета и использовать тему High Contrast`,
  'ViewerBusyDialog.openReport.txt': () => `Открывается отчет...`,
  'ViewerBusyDialog.prepareExport.txt': () => `Подготовка к экспорту...`,
  'ViewerBusyDialog.preparePrint.txt': () => `Подготовка к печати...`,
  'PDFGeneration.printingReport.txt': () => `Генерируется отчет в формате PDF. Она будет загружена по готовности.`,
  'PDFGeneration.fileName.fmt': ({fileName, date}) => `${fileName} дата ${date}`,
  'VisualElementActionUtil.actionMenuLabel.txt': () => `Выберите действие`,
  'VisualElementActionUtil.hierarchyExhausted.txt': () => `Вы достигли нижнего уровня иерархии.`,
  'VisualElementActionUtil.hierarchiesExhausted.txt': () => `Вы перешли на самый нижний уровень всех иерархий.`,
  'VisualElementActionUtil.drillLabel.fmt': ({value}) => `Детализировать ${value}`,
  'SaveImageUtil.snapshot.fmt': ({a0, a1, a2}) => `Моментальный снимок ${a0} ${a1} в ${a2}`,
  'ObjectToolbarIcon.SaveImageTooltip.txt': () => `Сохранение изображения`,
  'ObjectToolbarIcon.PrintObject.txt': () => `Печать объекта...`,
  'ObjectToolbarIcon.ShareObject.txt': () => `Общий доступ к объекту...`,
  'ObjectToolbarIcon.OverflowButton.default.txt': () => `Дополнительно`,
  'ObjectToolbarIcon.OverflowButton.labeled.fmt': ({label}) => `Меню объекта для ${label}`,
  'ObjectToolbarIcon.Accelerator.txt': () => `Просмотр с помощью SAS® Graphics Accelerator`,
  'ZoomControl.button.tip.txt': () => `Масштаб`,
  'ZoomControl.button.zoomin.txt': () => `Увеличить масштаб`,
  'ZoomControl.button.zoomout.txt': () => `Уменьшить масштаб`,
  'ZoomControl.button.display.txt': () => `Элементы управления для изменения масштаба`,
  'ZoomControl.button.reset.txt': () => `Сбросить масштаб`,
  'ExpandControl.button.expand.txt': () => `Развернуть`,
  'ExpandControl.button.restore.txt': () => `Восстановить представление`,
  'ExpandControl.button.expand.tip.txt': () => `Максимизация`,
  'ExpandControl.button.restore.tip.txt': () => `Восстановить`,
  'ReportVisualContainer.sectionLink.notAllowed.maximize.txt': () => `Выполнить ссылки на страницы невозможно, пока этот объект развернут.`,
  'DragModeControl.button.pan.tip.txt': () => `Панорама`,
  'DragModeControl.button.circular.tip.txt': () => `Круговой выбор`,
  'DragModeControl.button.freeform.tip.txt': () => `Выбор произвольной формы`,
  'DragModeControl.button.rectangular.tip.txt': () => `Прямоугольный выбор`,
  'DragModeControl.button.zoom.tip.txt': () => `Масштабирование прямоугольника`,
  'ReportXMLDialog.title.txt': () => `XML-файл отчета`,
  'ReportXMLDialog.closeButton.txt': () => `Закрыть`,
  'ReportXMLDialog.copyButton.txt': () => `Копировать в буфер обмена`,
  'ReportXMLDialog.error.txt': () => `Ошибка при загрузке XML-файла отчета`,
  'ErrorDialog.error.txt': () => `Произошла ошибка. Обратитесь к системному администратору.`,
  'Application.banner.txt': () => `Средство просмотра отчетов SAS®`,
  'Application.wip.banner.txt': () => `SAS® Visual Analytics - средство просмотра отчетов`,
  'Application.productName.txt': () => `SAS® Visual Analytics`,
  'OpenReportDialog.title.txt': () => `Открытие отчета`,
  'OpenReportDialog.reports.txt': () => `Отчеты:`,
  'OpenReportDialog.cancel.txt': () => `Отмена`,
  'OpenReportDialog.ok.txt': () => `OK`,
  'AriaLive.numberOfObjectsUpdated.fmt': ({count}) => `${count} объектов обновлено`,
  'AriaLive.oneObjectUpdated.txt': () => `1 объект обновлен`,
  'AriaLive.reportOpened.txt': () => `Отчет открыт`,
  'AriaLive.reportClosed.txt': () => `Отчет закрыт`,
  'ExportData.generating.txt': () => `Генерирование экспорта. Он будет загружен по готовности.`,
  'ExportData.warning.txt': () => `Ошибка при создании данных`,
  'ExportData.nodata.txt': () => `Отсутствуют данные для экспорта`,
  'ExportData.exportData.txt': () => `Экспорт данных...`,
  'PlaybackAnimationDialog.saveButton.txt': () => `Сохранить`,
  'PlaybackAnimationDialog.cancelButton.txt': () => `Отмена`,
  'PlaybackAnimationDialog.playButton.txt': () => `Воспроизвести отчет`,
  'PlaybackAnimationDialog.title.txt': () => `Редактировать воспроизведение`,
  'PlaybackAnimationDialog.transitionUnit.label.txt': () => `Переходная единица:`,
  'PlaybackAnimationDialog.transitionUnit.page.txt': () => `Страница`,
  'PlaybackAnimationDialog.transitionUnit.object.txt': () => `Объект`,
  'PlaybackAnimationDialog.secondsPerUnit.label.txt': () => `Секунд на единицу:`,
  'PlaybackAnimationDialog.showMaximized.label.txt': () => `Показать развернутые объекты:`,
  'PlaybackAnimationDialog.showCanvasOnly.label.txt': () => `Показать только холст:`,
  'PlaybackAnimationDialog.showTimer.label.txt': () => `Показать таймер:`,
  'PlaybackAnimationDialog.showNavigationControls.label.txt': () => `Показывать элементы управления навигацией при щелчке или касании:`,
  'PlaybackNavigationControls.previousPage.txt': () => `Предыдущая страница`,
  'PlaybackNavigationControls.nextPage.txt': () => `Следующая страница`,
  'PlaybackNavigationControls.previousObject.txt': () => `Предыдущий объект`,
  'PlaybackNavigationControls.nextObject.txt': () => `Следующий объект`,
  'TransportConnection.generateReportTimeout.txt': () => `Загрузка отчета занимает долгое время. Продолжить?`,
  'TransportConnection.openReport.txt': () => `Открытие отчета`,
  'ViewerContainer.reportNotFound.fmt': ({location}) => `Указанный отчет в следующем месте не существует: ${location}`,
  'Hierarchy.expand.fmt': ({label}) => `Развернуть ${label}`,
  'Hierarchy.collapse.fmt': ({label}) => `Свернуть ${label}`,
  'GraphElementDecorator.overview.txt': () => `Обзор`,
  'CompositeGraphElementDecorator.hideOverview.txt': () => `Скрыть обзор`,
  'CompositeGraphElementDecorator.showOverview.txt': () => `Отобразить обзор`,
  'TitleInfoButton.tooltip.txt': () => `Информация`,
  'token.closeIcon.tooltip.txt': () => `Удалить`,
  'token.grouptoken.moreoption.label.txt': () => `Больше...`,
  'token.grouptoken.moreoptionheader.label.fmt': ({count}) => `Первые ${count} элементов:`,
  'token.grouptoken.ariaLabel.fmt': ({name, count}) => `${name}, число элементов в группе: ${count}`,
  'token.grouptoken.closeIcon.tooltip.txt': () => `Удалить группу`,
  'token.grouptoken.countlabel.fmt': ({count}) => `(${count})`,
  'token.prevButton.tooltip.txt': () => `Прокрутить к предыдущему элементу`,
  'token.nextButton.tooltip.txt': () => `Прокрутить к следующему элементу`,
  'token.menu.tooltip.txt': () => `Список элементов`,
  'token.menuItem.customtooltip.fmt': ({value}) => `Удалить ${value}`,
  'token.menuItem.customAriaLabel.fmt': ({value}) => `${value}, Для того, чтобы удалить элемент, нажмите Delete.`,
  'token.containeritems.label.txt': () => `элементы`,
  'token.grouptoken.menu.desc.txt': () => `. Нажмите пробел, чтобы активировать меню и перейдите к нужному элементу с помощью клавиш со стрелками`,
  'SectionSelectionBar.noSelections.txt': () => `Не выбрано ни одного элемента`,
  'SectionSelectionBar.title.txt': () => `Фильтры:`,
  'CheckboxList.selectAll.txt': () => `Выбрать все`,
  'CheckboxList.clearSelection.txt': () => `Очистить выделение`,
  'CheckboxList.clearSelection.fmt': ({count}) => `Очистить выделение (${count})`,
  'ExplanationInfoDialog.title.fmt': ({label}) => `Объяснение ${label}`,
  'ExplanationInfoDialog.loading.txt': () => `Подготовка объяснения...`,
  'ExplanationInfoDialog.cancel.txt': () => `Отмена`,
  'ExplanationInfoDialog.close.txt': () => `Закрыть`,
  'PromptHeader.emptyReport.txt': () => `Чтобы создать параметр отчета, перетащите сюда элемент данных или элемент управления.`,
  'PromptHeader.emptyPage.txt': () => `Чтобы создать параметр страницы, перетащите сюда элемент данных или элемент управления.`,
  'ZeroState.editMode.txt': () => `Перетащите сюда шаблон, элементы данных или объекты.`,
  'ZeroState.viewMode.txt': () => `Отсутствует содержимое для отображения.`,
  'ObjectStatus.assignData.txt': () => `Назначить данные`,
  'ObjectStatus.selectImage.txt': () => `Выбрать изображение`,
  'ObjectStatus.selectJob.txt': () => `Выбрать работу`,
  'ObjectStatus.cancelLoading.txt': () => `Отменить загрузку`,
  'ObjectStatus.loadingCanceled.txt': () => `Загрузка отменена`,
  'ObjectStatus.resumeLoading.txt': () => `Возобновить загрузку`,
  'MainSearchPanel.searchResults.txt': () => `Результаты поиска`,
  'MainSearchPanel.features.txt': () => `Функции`,
  'MainSearchPanel.newMapFeature.txt': () => `Новая функция карты`,
  'MainSearchPanel.newMapFeature.title.txt': () => `Новая функция карты`,
  'MainSearchPanel.newPin.txt': () => `Новый пин`,
  'MainSearchPanel.newRoute.txt': () => `Новый маршрут`,
  'MainSearchPanel.newGeographicArea.txt': () => `Новая географическая область`,
  'MainSearchPanel.newMyLocationPin.txt': () => `Пин-код моего местоположения`,
  'MainSearchPanel.show.txt': () => `Показать`,
  'MainSearchPanel.show.all.txt': () => `Показать все`,
  'MainSearchPanel.hide.txt': () => `Скрыть`,
  'MainSearchPanel.hide.all.txt': () => `Скрыть все`,
  'MainSearchPanel.delete.txt': () => `Удаление`,
  'MainSearchPanel.delete.all.txt': () => `Удалить все`,
  'MainSearchPanel.convert.txt': () => `Преобразование результатов поиска в пины`,
  'MainSearchPanel.convert.all.txt': () => `Преобразование всех результатов поиска в пины`,
  'MainSearchPanel.showPinLabels.txt': () => `Показать метки контактов`,
  'GeographicAreaPanel.title.txt': () => `Географическая зона`,
  'GeographicAreaPanel.draw.txt': () => `Область рисования`,
  'GeographicAreaPanel.label.txt': () => `Ярлык:`,
  'GeographicAreaPanel.location.txt': () => `Местоположение:`,
  'GeographicAreaPanel.location.search.placeholder.txt': () => `Ищите или щелкните на карте`,
  'GeographicAreaPanel.type.txt': () => `Тип:`,
  'GeographicAreaPanel.unit.txt': () => `Единица:`,
  'GeographicAreaPanel.distance.txt': () => `Расстояние:`,
  'GeographicAreaPanel.duration.txt': () => `Продолжительность:`,
  'GeographicAreaPanel.travelMode.txt': () => `Режим путешествия:`,
  'GeographicAreaPanel.traffic.txt': () => `Включить трафик:`,
  'GeographicAreaPanel.distanceTypes.distance.txt': () => `Расстояние`,
  'GeographicAreaPanel.distanceTypes.travelTime.txt': () => `Время в пути`,
  'GeographicAreaPanel.distanceTypes.travelDistance.txt': () => `Расстояние путешествия`,
  'GeographicAreaPanel.distanceUnits.miles.txt': () => `Мили`,
  'GeographicAreaPanel.distanceUnits.kilometers.txt': () => `Километры`,
  'GeographicAreaPanel.timeUnits.minutes.txt': () => `Минут`,
  'GeographicAreaPanel.travelMode.direct.txt': () => `Прямое`,
  'GeographicAreaPanel.travelMode.driving.txt': () => `Легковая машина`,
  'GeographicAreaPanel.travelMode.trucking.txt': () => `Грузовик`,
  'GeographicAreaPanel.travelMode.walking.txt': () => `Пешком`,
  'GeographicAreaPanel.traffic.none.txt': () => `Нет`,
  'GeographicAreaPanel.traffic.live.txt': () => `Трафик в реальном времени`,
  'GeographicAreaPanel.traffic.mon.txt': () => `Понедельник`,
  'GeographicAreaPanel.traffic.tue.txt': () => `Вторник`,
  'GeographicAreaPanel.traffic.wed.txt': () => `Среда`,
  'GeographicAreaPanel.traffic.thu.txt': () => `Четверг`,
  'GeographicAreaPanel.traffic.fri.txt': () => `Пятница`,
  'GeographicAreaPanel.traffic.sat.txt': () => `Суббота`,
  'GeographicAreaPanel.traffic.sun.txt': () => `Воскресенье`,
  'GeographicAreaPanel.menu.clear.txt': () => `Очистить географическую зону`,
  'GeographicAreaPanel.menu.link.txt': () => `Привязка адреса к элементам данных и контактам по умолчанию`,
  'GeographicAreaPanel.menu.unlink.txt': () => `Отменить связь с географическим адресом`,
  'GeographicAreaPanel.demographics.txt': () => `Демография`,
  'GeographicAreaPanel.demographics.set.txt': () => `Отобразить демографические показатели`,
  'GeographicAreaPanel.demographics.menu.expand.txt': () => `Развернуть вид`,
  'GeographicAreaPanel.demographics.menu.edit.txt': () => `Редактировать демографические данные`,
  'GeographicAreaPanel.demographics.menu.delete.txt': () => `Удалить демографические данные`,
  'GeographicAreaPanel.demographics.expired.txt': () => `Необходимо перезагрузить демографические данные`,
  'GeographicAreaPanel.demographics.reload.txt': () => `Обновить демографические данные`,
  'RoutePanel.title.txt': () => `Маршрутизировать`,
  'RoutePanel.draw.txt': () => `Прочертить маршрут`,
  'RoutePanel.label.txt': () => `Ярлык:`,
  'RoutePanel.locations.txt': () => `Местоположения`,
  'RoutePanel.menu.clear.txt': () => `Очистить маршрут`,
  'RoutePanel.menu.reverse.txt': () => `Обратный маршрут`,
  'RoutePanel.menu.add.txt': () => `Добавить местоположение маршрута`,
  'RoutePanel.menu.delete.txt': () => `Удалить местоположение маршрута`,
  'RoutePanel.menu.unlink.txt': () => `Отменить связь с местоположением маршрута`,
  'RoutePanel.menu.arrows.txt': () => `Стрелки маршрута`,
  'RoutePanel.menu.arrows.hide.txt': () => `Скрыть стрелки маршрута`,
  'RoutePanel.menu.arrows.show.txt': () => `Показать стрелки маршрута`,
  'RoutePanel.menu.arrows.oneway.txt': () => `Односторонние`,
  'RoutePanel.menu.arrows.twoway.txt': () => `Двусторонние`,
  'RoutePanel.route.width.txt': () => `Ширина маршрута`,
  'RoutePanel.distance.txt': () => `Расстояние:`,
  'RoutePanel.distance.miles.fmt': ({distance}) => `${distance} миль`,
  'RoutePanel.distance.kilometers.fmt': ({distance}) => `${distance} км`,
  'PinPanel.pinTitle.txt': () => `Закрепить`,
  'PinPanel.addDescription.txt': () => `Добавить описание`,
  'PinPanel.deleteDescription.txt': () => `Удалить описание`,
  'PinPanel.newPin.txt': () => `Создать прикрепление в этом месте`,
  'PinPanel.deletePin.txt': () => `Удалить прикрепление`,
  'PinPanel.linkPins.txt': () => `Связывание контактов с элементами данных по умолчанию`,
  'PinPanel.unlinkAllItems.txt': () => `Отменить связь со всеми элементами`,
  'PinPanel.unlinkItems.txt': () => `Отключить элементы`,
  'PinPanel.label.txt': () => `Ярлык:`,
  'PinPanel.location.txt': () => `Местоположение:`,
  'PinPanel.description.txt': () => `Описание:`,
  'PinPanel.linked.txt': () => `СВЯЗАННЫЙ`,
  'PinPanel.searchPlaceholder.txt': () => `Найдите или щелкните на карте`,
  'PinPanel.addRoute.txt': () => `Добавить маршрут`,
  'PinPanel.addArea.txt': () => `Добавить географический регион`,
  'PinPanel.addArea.title.txt': () => `Добавить географическую область`,
  'PinPanel.myLocationTitle.txt': () => `Мое местоположение`,
  'PinPanel.deleteMyLocationPin.txt': () => `Удалить булавку «Мое местоположение»`,
  'PinPanel.enableAutoUpdate.txt': () => `Включить автоматическое обновление «Мое местоположение»`,
  'PinPanel.disableAutoUpdate.txt': () => `Отключить автоматическое обновление «Мое местоположение»`,
  'PinPanel.editAutoRefreshInterval.txt': () => `Изменить интервал автообновления «Мое местоположение»...`,
  'PinPanel.linkToPin.txt': () => `Ссылка на закрепление`,
  'PinPanel.useCurrentLocation.txt': () => `Использовать текущее местоположение булавки`,
  'PinPanel.notDrawn.txt': () => `Не нарисовано`,
  'DemographicsSelectorDialog.title.txt': () => `Установить демографию`,
  'DemographicsSelectorDialog.cancel.txt': () => `Отмена`,
  'DemographicsSelectorDialog.ok.txt': () => `ОК`,
  'DemographicsSelectorDialog.country.txt': () => `Страна/регион`,
  'DemographicsSelectorDialog.tab.basic.txt': () => `Основные`,
  'DemographicsSelectorDialog.tab.advanced.txt': () => `Расширенные`,
  'DemographicsSelectorDialog.tab.recent.txt': () => `Последние`,
  'DemographicsSelectorDialog.categories.txt': () => `Категории`,
  'DemographicsSelectorDialog.category.income.txt': () => `Доход`,
  'DemographicsSelectorDialog.category.age.txt': () => `Возраст`,
  'DemographicsSelectorDialog.category.households.txt': () => `Группа`,
  'DemographicsSelectorDialog.category.housing.txt': () => `Жилье`,
  'DemographicsSelectorDialog.category.maritalstatus.txt': () => `Семейное положение`,
  'DemographicsSelectorDialog.category.population.txt': () => `Население`,
  'DemographicsSelectorDialog.category.usergroup.txt': () => `Группа пользователей`,
  'DemographicsSelectorDialog.category.health.txt': () => `Работоспособность`,
  'DemographicsSelectorDialog.category.education.txt': () => `Образование`,
  'DemographicsSelectorDialog.category.business.txt': () => `Бизнес`,
  'DemographicsSelectorDialog.category.race.txt': () => `Раса`,
  'DemographicsSelectorDialog.category.spending.txt': () => `Потребление`,
  'DemographicsSelectorDialog.category.behaviors.txt': () => `Поведения`,
  'DemographicsSelectorDialog.category.jobs.txt': () => `Задания`,
  'DemographicsSelectorDialog.category.poverty.txt': () => `Нехватка`,
  'DemographicsSelectorDialog.category.tapestry.txt': () => `Гобелен`,
  'DemographicsSelectorDialog.category.atrisk.txt': () => `С риском`,
  'DemographicsSelectorDialog.category.keyfacts.txt': () => `Ключевые факторы`,
  'DemographicsSelectorDialog.category.supplyanddemand.txt': () => `Предложение и спрос`,
  'DemographicsSelectorDialog.category.policy.txt': () => `Политика`,
  'DemographicsSelectorDialog.category.landscape.txt': () => `Альбомная`,
  'DemographicsSelectorDialog.category.crime.txt': () => `Преступность`,
  'ManageColumns.title.txt': () => `Управление столбцами`,
  'ManageColumns.ok.txt': () => `ОК`,
  'ManageColumns.cancel.txt': () => `Отмена`,
  'ManageColumns.hiddenColumns.txt': () => `Скрытые столбцы`,
  'ManageColumns.displayedColumns.txt': () => `Отображаемые столбцы`,
  'SearchResultPanel.title.txt': () => `Результат поиска`,
  'SearchResultPanel.menu.delete.txt': () => `Удалить результат поиска`,
  'SearchResultPanel.convert.txt': () => `Преобразовать в закрепление`,
  'DemographicsResultsDialog.title.txt': () => `Демография`,
  'DemographicsResultsDialog.cancel.txt': () => `Отмена`,
  'DemographicsResultsDialog.close.txt': () => `Закрыть`,
  'DemographicsResultsDialog.edit.txt': () => `Редактировать`,
  'DemographicsResultsDialog.layout.page.txt': () => `Страница`,
  'DemographicsResultsDialog.layout.list.txt': () => `Список`,
  'DemographicsResultsDialog.layout.tile.txt': () => `Плитка`,
}
export default localizers;
